module.exports = __webpack_public_path__ + "img/Icon-navigation-search-light.c1bd2e23.svg";